import Component from 'vue-class-component';
import { WidgetTeacherSectionItem } from '@/homework/models/widget-teacher-section-item.model';
import { Mixins, Prop } from 'vue-property-decorator';
import  EdHomeworkViewer  from '../ed-homework-viewer/ed-homework-viewer.vue';
import {
  HOMEWORK_STATUS,
  _HOMEWORKS_STORE,
  TEACHER_HOMEWORK_STATUS_ICON,
  HOMEWORKS_EVENTS,
  TEACHER_WIDGET_TASK_TABS,
  GRADING_SCALES,
  HOMEWORK_HISTORY_STATUS
} from '@/homework/values/homeworks.values';
import {SECTIONS_TYPE_FILE_DOWLOAD, SECTION_TYPES, TYPE_BOARD_DRAFT_RESPONSE_OPTIONS} from '@/content/values/sections';
import KEYS from '../../../values/keys';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { WriteObjectMixin } from '@/courses/mixins/write-object.mixin';
import { HomeworkMixin } from '@/homework/mixins/homework.mixin';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { TYPE_BOARD_DRAFT_FEEDBACK_OPTIONS }  from '@/content/values/sections';
import { SERVER_HOSTNAME } from '@/shared/enums/request.enum';
import { AuthenticatedFileDownloadProvider } from '@/shared/providers/authenticated-file-download.provider';
import EdListHomeworkHistoryComponent from '@/homework/component/ed-list-homework-history/ed-list-homework-history.component.vue';
import { Section } from '@/courses/models/section.model';
@Component({
  components: {
    EdHomeworkViewer,
    EdListHomeworkHistoryComponent
  }
})
export default class EdHomeworkTeacherSectionPersonItem extends Mixins(HomeworkMixin, WriteObjectMixin, CourseToolsMixin) {

  @Prop() readonly widgetTeacherSectionItem: WidgetTeacherSectionItem;
  @Prop() readonly showFeedbackInfo: boolean;

  private history : any;

  get person() {
    return this.widgetTeacherSectionItem.student;
  }

  get response() {
    return this.widgetTeacherSectionItem.response;
  }

  get responseDraft() {
    return this.widgetTeacherSectionItem.responseDraft;
  }

  get feedbackDraft() {
    return this.widgetTeacherSectionItem.feedbackDraft;
  }

  get feedback() {
    let fb = this.widgetTeacherSectionItem.feedback;
    return fb && HOMEWORK_STATUS.NEW === fb.status ? null:fb;
  }

  get classId() {
    return this.widgetTeacherSectionItem.classId;
  }

  get courseId() {
    return this.widgetTeacherSectionItem.courseId;
  }

  get section() {
    return this.widgetTeacherSectionItem.section;
  }

  get gradingDetails() {
    return this.widgetTeacherSectionItem.gradingDetails;
  }

  get isHomeworkGraded(){
    return this.response && (this.response.status == HOMEWORK_STATUS.GRADED || this.response.status == HOMEWORK_STATUS.FINISHED);
  }

  get grade() {
    if (this.isHomeworkGraded && this.feedback && (this.feedback.grade || this.feedback.grade == 0)) {
      return this.course?.hasGrading ? this.feedback.gradeName || this.feedback.grade : this.feedback.grade;
    }
    return null;
  }
  
  get course() {
    return this.getCourseFromStore({courseId: this.courseId, classId: this.classId });
  }

  get gradeDetails() {
    if(this.isHomeworkGraded) {
      if(this.course.hasGrading){
        if (this.gradingDetails?.length == 1) {
          return `${this.$t('courses.grade.gradeW')}: ${this.gradingDetails[0].gradeName ? this.gradingDetails[0].gradeName : this.gradingDetails[0].type == GRADING_SCALES.PERCENTAGE ? `${this.gradingDetails[0].value}%` : this.gradingDetails[0].points }, 
            ${this.$t('courses.grade.points')}: ${this.gradingDetails[0].points}/${this.gradingDetails[0].itemPoints}, 
            ${this.gradingDetails[0].value}%`
        } else if (this.gradingDetails?.length > 1) {
          let grades = [];
          this.gradingDetails.forEach((el, i) => {
            grades.push(`${this.$t('courses.grade.gradeW')} Q${i+1}: ${el.gradeName ? el.gradeName : el.type == GRADING_SCALES.PERCENTAGE ? `${el.value}%` : el.points}, 
              ${this.$t('courses.grade.points')}: ${el.points}/${el.itemPoints}, 
              ${el.value}%`)
          })
          return grades
        } else {
          return this.feedback.grade;
        }
      }
      }else{
        return this.feedback.grade;
      }
  }

  get urlDownload() {
    let documentDetail = this.response && this.response.type ? this.response : this.section;
    
    if(SECTIONS_TYPE_FILE_DOWLOAD.some(fileType => fileType === documentDetail.type)) {
      const asset = documentDetail.type === SECTION_TYPES.LESSON_TEXT.code
          ? (documentDetail as Section).assetsInfo[0].pdfHash
          : documentDetail.text;
      let name = documentDetail.name;
      let nameWithExt;
      if (SECTION_TYPES.LESSON_IMAGES.code == documentDetail.type) {
        nameWithExt = this.safeBase64Encode(name + '.jpg');
        let nameReplaced = nameWithExt.replace(/\//g, '_');
        return `${process.env[SERVER_HOSTNAME.COMMON]}/download/object/image/${asset}/${nameReplaced}`;
      } else {
        let ext = SectionsProvider.getExtensionFromSectionType(documentDetail.type);
        nameWithExt = this.safeBase64Encode(name + '.' + ext);
        let nameReplaced = nameWithExt.replace(/\//g, '_');
        return `${process.env[SERVER_HOSTNAME.COMMON]}/download/object/${ext}/${asset}/${nameReplaced}`;
      }
    }
    return '';
  }

  get gradeTooltip() {
    return this.isHomeworkGraded ? this.$i18n.t('homeworks.alreadyGraded') : this.$i18n.t('homeworks.setGrade');
  }
  
  get feedbackTooltip() {
    return this.isHomeworkGraded ? this.$i18n.t('homeworks.feedbackSent') : this.$i18n.t('homeworks.uploadFeedback');
  }

  get isHomeworkDraft() {  
    return this.responseDraft || (!this.responseDraft && !this.response);
  }

  get status() {
    return this.response ? this.response.status : this.responseDraft ? this.responseDraft.status : this.section.homeworkStatus ? this.section.homeworkStatus : '';
  }

  get isHomeworkFeedbackDraft() {
    return this.status === HOMEWORK_STATUS.FEEDBACK_DRAFT;
  }

  get isHomeworkSeen() {
    return this.status === HOMEWORK_STATUS.SEEN;
  }

  get statusIcon() {    
    return TEACHER_HOMEWORK_STATUS_ICON[this.status];
  }

  get boardGroupHash() {
    return this.responseDraft ? this.responseDraft.boardGroup
          : this.widgetTeacherSectionItem.feedbackDraft ? this.widgetTeacherSectionItem.feedbackDraft.boardGroup
          : null
  }

  get validateResponseDraftCurrentVersion() : boolean{
    return  this.responseDraft && this.responseDraft.type === SECTION_TYPES.LESSON_BOARD.code;
  }

  get validateFeedbackDraftCurrentVersion() : boolean{
    return this.feedbackDraft && this.feedbackDraft.type === SECTION_TYPES.LESSON_BOARD.code;
  }

  get canOpenWithCurrentVersion() : boolean {
    return ((this.validateDraftBoardOptions(this.section, TYPE_BOARD_DRAFT_RESPONSE_OPTIONS) && this.validateResponseDraftCurrentVersion)
            || (this.validateDraftBoardOptions(this.section, TYPE_BOARD_DRAFT_FEEDBACK_OPTIONS) && this.validateFeedbackDraftCurrentVersion))
        || (!this.responseDraft && !this.feedbackDraft);
  }

  get homeworkId() : number {
    return this.widgetTeacherSectionItem?.section?.homeworkId;
  }

  onClickGrade(){
    if(!this.isHomeworkGraded) {
      this.$emit('onShowGrade');
    }
  }

  async downloadHomework() {
    this.setSeenStatusDownloading();
    if(this.section.type == SECTION_TYPES.LESSON_SPLIT_WRITE.code 
      || this.section.type == SECTION_TYPES.LESSON_SPLIT_TYPE.code ) {
      await this.downloadFiles();
    } else {
      await AuthenticatedFileDownloadProvider.download(this.urlDownload, this.section.name);
    }
  }

  async viewHomework(clearHistory) {
    try {
      if(clearHistory){
        this.history = null;
      }
      if(this.response?.homeworkAssetInfo) {
        let response = await this.validateHomeworkStatus(this.response.homeworkAssetInfo.hash);
        if(!response) {
          this.createMessageModal(String(this.$i18n.t('homeworks.documentStatus')), KEYS.EVENT_TYPES.WARNING);
          return;
        }
      }
      this.setSeenStatus();
      this.createModal();
    } catch(err) {
      throw new Error(err);
    }
  }

  private createMessageModal(body: string , type: string) {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('common.information'),
      body: body,
      type: type
    });
  }

  openFeedback() {
    let params = {
      section : {
        ...this.feedback,
        courseId: this.widgetTeacherSectionItem.courseId,
        classId: this.classId,
        sectionId: this.section.sectionId,
        assetsInfo: [this.feedback.homeworkAssetInfo],
        section: {
          ...this.section,
          id: this.section.sectionId
        }
      },
      student: this.person,
      viewer: SECTION_TYPES[this.feedback.type]['viewerResponse']
    };
    this.$EdModal.createModal(EdHomeworkViewer, params);
  }

  setSeenStatus() {
    if(!(this.response && (this.response.status === HOMEWORK_STATUS.NEW || this.response.status === HOMEWORK_STATUS.SEEN))) {
      return;
    }

    this.response.status = HOMEWORK_STATUS.SEEN;

    if(this.validateDraftBoardOptions(this.section, TYPE_BOARD_DRAFT_FEEDBACK_OPTIONS)) {
      this.response.status = HOMEWORK_STATUS.FEEDBACK_DRAFT;
    }
  }

  private updateTeacherHomeworkStatus(studentId : number) : void {

    if(studentId !== this.person.id || this.$store.state.HomeworksStore.teacherWidgetTabSelected !== TEACHER_WIDGET_TASK_TABS.BY_SECTIONS){
      return;
    }

    let courseIndex = this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content.findIndex(cs => cs.id == this.person.courseId);

    if(!this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex]) {
      return;
    }

    let personIndex = this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex].persons.content.findIndex(s => s.id == this.person.id);
    if(personIndex === -1) {
      return;
    }
    
    if(this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content[courseIndex].persons.content[personIndex].homeworks.content.length > 0){
      let student = {...this.person};
      student.homeworks.page = 0;
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.UPDATE_WIDGET_TEACHER_PERSON_SELECTED_ALL, {student, isStatudReload: false});
    }
  }
 
  private setSeenStatusDownloading() : void { 
    if(!(this.response && this.response.status === HOMEWORK_STATUS.NEW)) {
      return;
    }

    this.response.status = HOMEWORK_STATUS.SEEN;

    this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.UPDATE_TEACHER_HOMEWORK_STATUS, { 
      req: this.response, student: this.person
    });
  }

  createModal() {
    let params;
    if (this.response){
      params = this.obtainViewerResponseParams();
      this.$EdModal.createModal(EdHomeworkViewer, params);
    } else {
      params = this.obtainDraftResponseParams();
      const title = this.$i18n.t('errors.ups');
      const body = this.$i18n.t('homeworks.homeworkDraftNotAvailable');
      if(params.section.type === SECTION_TYPES.LESSON_MATERIAL.code) {
        // tell the viewer that show this as pdf
        params.section.type = SECTION_TYPES.LESSON_PDF.code;
      }
      this.getCurrentHomeworkDraft(params.section.sectionId, params.section.studentId)
          .then(response => {
            params.section.assetsInfo = [response.homeworkDraftAssetInfo];
            this.$EdModal.createModal(EdHomeworkViewer, params);
          })
          .catch(error => {
            this.$EdModal.createMessageModal({
              title: title,
              body: body,
              type: KEYS.EVENT_TYPES.DANGER
            });
          });
    }
  }

  async downloadFiles() {
    let sections = this.section.sections;
    let problem = null;
    let solution = null;
    let answer = null;
    if(this.section.assetsInfo) {
      answer = {
        type: SECTION_TYPES.LESSON_PDF.code,
        assetsInfo: this.section.assetsInfo,
        text: this.section.text
      };
    }
    if(sections) {
      sections.forEach((s) => {
        problem  = this.getProblemToDownload(s, problem)
        solution = this.getSolutionToDownload(s, solution);
      });
    }
    let nameWithExt = this.safeBase64Encode(this.section.name + '.zip');
    let nameReplaced = nameWithExt.replace(/\//g, '_');
    let files = `${nameReplaced}?hash=${problem.assetsInfo[0].hash}`;
    if(answer) {
      files += `&hash=${answer.assetsInfo[0].hash}`;
    }
    if(solution) {
      files += `&hash=${solution.assetsInfo[0].hash}`;
    }
    if(this.response) {
      files += `&hash=${this.response.homeworkAssetInfo.hash}`;
    }
    await AuthenticatedFileDownloadProvider.download(
      `${process.env[SERVER_HOSTNAME.COMMON]}/download/object/zip/${files}`,
      `${this.section.name}.zip`
    );
  }

  private obtainViewerResponseParams(): any {
    let feedbackDraft = this.widgetTeacherSectionItem.feedbackDraft;
    return {
      section : {
        ...this.response,
        courseId: this.widgetTeacherSectionItem.courseId,
        assetsInfo: [this.response.homeworkAssetInfo],
        section: {
          ...this.section,
          id: this.section.sectionId
        },
        classId: this.classId,
        sectionId: this.section.sectionId,
        homeworkDraftAssetInfo: feedbackDraft ? feedbackDraft.homeworkDraftAssetInfo : null
      },
      student: this.person,
      viewer: this.getHomeworkViewer(
        { ...this.response, section: this.section },
        'viewerResponse'
      ),
      history: this.history
    };
  }

  private obtainDraftResponseParams(viewerKey : string = 'viewerResponse'): any {

    return {
      section : {
        ...this.responseDraft,
        assetsInfo: this.section.assetsInfo ? [...this.section.assetsInfo] : null,
        section: this.section,
        type: this.section.type,
        text: this.section.text,
        sectionId: this.section.sectionId,
        classId: this.classId,
        studentId: this.person.id,
        sections: this.section.sections
      },
      student: this.person,
      canResponse: false,
      viewer: this.getHomeworkViewer({...this.responseDraft, section: this.section}, viewerKey),
      history: this.history,
      responseDraft: this.responseDraft,
    };
  }

  private joinHomework() : any {
    if (!this.canOpenWithCurrentVersion) {
      this.showCantOpenHomeworkModal();
      return;
    }

    if (this.isHomeworkDraft) {
      this.section.homeworkStatus = HOMEWORK_STATUS.DRAFT;
    } else {
      this.setSeenStatus();
    }

    let params = this.obtainDraftResponseParams('viewerHomework');
    this.$EdModal.createModal(EdHomeworkViewer, {...params, canResponse: true});
  }

  public openHistory() {
    let data = {
      classId: this.classId,
      sectionId: String(this.section.id),
      sectionName: this.section.name,
      historyStatus: HOMEWORK_HISTORY_STATUS.FEEDBACK,
      studentId: this.person.id,
      homeworkId: this.homeworkId,
      title: this.person.fullName
    }
    this.$EdModal.createModal(EdListHomeworkHistoryComponent, {data});
  }

  public openSnapShot(params) {
    if (this.person.id === params.studentId){
      this.history = {...params, show:true}
      this.viewHomework(false);
    }
  }

  private safeBase64Encode(input: string) {
    return btoa(String.fromCharCode(...new TextEncoder().encode(input)));
  }

  mounted() {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS, this.updateTeacherHomeworkStatus);
    this.$edEventBus.$on(HOMEWORKS_EVENTS.OPEN_HOMEWORK_SNAPSHOT, this.openSnapShot);
  }

  beforeDestroy() {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS, this.updateTeacherHomeworkStatus);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.OPEN_HOMEWORK_SNAPSHOT, this.openSnapShot);
  }
}
